import type { RemoteSlice } from '../lib/createRemoteSlice';
import { confirmLeavingWorkspaceSlice } from './confirmLeavingWorkspace';
import { workspaceSettingsSlice } from './workspaceSettings';

export const overlaySlices: RemoteSlice<any, any>[] = [workspaceSettingsSlice, confirmLeavingWorkspaceSlice];
